import Rebase from 're-base'
import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/auth'
 
 
const app = firebase.initializeApp({
    apiKey: "AIzaSyAGKKmJCm9wchBPEUizbdxlCoxI18ibV84",
    authDomain: "boiler-faves.firebaseapp.com",
    databaseURL: "https://boiler-faves.firebaseio.com",
    projectId: "boiler-faves",
    storageBucket: "boiler-faves.appspot.com",
    messagingSenderId: "93674517189"
})
 
 
 
const db = firebase.database(app)
 
export const auth = app.auth()
export const googleProvider = new firebase.auth.GoogleAuthProvider()
 
export default Rebase.createClass(db)


// WEBPACK FOOTER //
// ./src/base.js